// Dialog text at the size of the page grids: the MUI defaults (14 px cells, 16 px inputs) look oversized next to them.
export const COMPACT_DIALOG_SX = {
	"& .MuiTableCell-root": { fontSize: 13 },
	"& .MuiTableCell-head": {
		fontSize: 12,
		fontWeight: 600,
		color: "text.secondary",
	},
	"& .MuiInputBase-input": { fontSize: 13 },
} as const;

export const COMPACT_OPTION_SX = { fontSize: 13 } as const;

// Editable fields keep the focused look, so they stand out from the read-only ones.
// An error keeps its own red, and a field disabled for now (e.g. writes locked) keeps its grey.
export const EDITABLE_FIELD_SX = {
	"& .MuiOutlinedInput-root:not(.Mui-error):not(.Mui-disabled) fieldset, & .MuiOutlinedInput-root:not(.Mui-error):not(.Mui-disabled):hover fieldset":
		{ borderColor: "primary.main", borderWidth: 1 },
	"& .MuiInputLabel-root:not(.Mui-error):not(.Mui-disabled)": {
		color: "primary.main",
	},
} as const;
